export interface NotificationMetadata {
  bookingId?: string;
  BOOKING_ID?: string;
  harborName?: string;
  mediationCaseId?: string;
  MEDIATION_CASE_ID?: string;
}

export interface INotificationData {
  id: string;
  title: string;
  description: string;
  metadata: NotificationMetadata;
  notification_type?: NotificationType;
  is_read: boolean;
  status: number;
  created_at: string;
}

export interface NotificationResponse {
  status: boolean;
  message: string;
  data: INotificationData;
}

export type SingleNotification = INotificationData;

export interface NotificationListQueryParams {
  page?: number;
  limit?: number;
  search?: string;
  startDate?: string;
  endDate?: string;
  is_read?: boolean;
}

export interface NotificationListResponse {
  total_items: number;
  current_page: number;
  total_pages: number;
  page_limit: number;
  data: INotificationData[];
}

export interface NotificationPreferencesDto {
  has_email_notifications?: boolean;
  has_push_notifications?: boolean;
  is_booking_notification_enabled?: boolean;
  is_payment_notification_enabled?: boolean;
  is_harbour_notification_enabled?: boolean;
  is_club_notification_enabled?: boolean;
  is_feedback_notification_enabled?: boolean;
  is_post_community_notification_enabled?: boolean;
  is_subscription_notification_enabled?: boolean;
  is_system_notification_enabled?: boolean;
  is_kyc_notification_enabled?: boolean;
}

export interface NotificationPreferencesResponseDto {
  has_email_notifications: boolean;
  has_push_notifications: boolean;
  is_booking_notification_enabled: boolean;
  is_payment_notification_enabled: boolean;
  is_harbour_notification_enabled: boolean;
  is_club_notification_enabled: boolean;
  is_feedback_notification_enabled: boolean;
  is_post_community_notification_enabled: boolean;
  is_subscription_notification_enabled: boolean;
  is_system_notification_enabled: boolean;
  is_kyc_notification_enabled: boolean;
}

export enum NotificationModuleType {
  BOOKING = 1,
  PAYMENTS = 2,
  HARBOUR = 3,
  CLUB = 4,
  SUBSCRIPTION = 5,
  POST_COMMUNITY = 6,
  FEEDBACK = 7,
  SYSTEM_NOTIFICATIONS = 8,
  KYC_NOTIFICATIONS = 9,
}

export enum NotificationType {
  GENERAL = 0,
  BERTH_BOOKING = 1,
  SERVICE_PROVIDER = 2,
  FEEDBACK = 3,
  CLUB_RESOURCE_BOOKING = 4,
  SERVICE_REQUEST = 5,
  SERVICE_REQUEST_APPROVED = 6,
  NEW_SERVICE_REQUEST = 7,

  POI_REQUEST_CREATED = 8,
  POI_REQUEST_UPDATED = 9,
  POI_REQUEST_DELETED = 10,
  POI_REQUEST_APPROVED = 11,
  POI_REQUEST_REJECTED = 12,

  BOOKING_CREATED = 13,
  BOOKING_UPDATED = 14,
  BOOKING_CANCELLED = 15,
  BOOKING_CONFIRMED = 16,
  BOOKING_PENDING_CONFIRMATION = 17,
  BOOKING_REMINDER = 18,
  BOOKING_APPROVED = 19,

  NEW_BOOKING_FOR_HARBOR = 20,
  BOOKING_MODIFIED_FOR_HARBOR = 21,
  BOOKING_CANCELLED_FOR_HARBOR = 22,

  CLUB_RESOURCE_BOOKING_CREATED = 23,
  CLUB_RESOURCE_BOOKING_CANCELLED = 24,
  NEW_CLUB_RESOURCE_BOOKING = 25,
  CLUB_RESOURCE_BOOKING_CANCELLED_FOR_CLUB = 26,
  CLUB_RESOURCE_BOOKING_PAYMENT_SUCCESS = 27,
  CLUB_RESOURCE_BOOKING_PAYMENT_FAILED = 28,

  SERVICE_PROVIDER_APPROVED = 29,
  SERVICE_PROVIDER_REJECTED = 30,

  FEEDBACK_NOTIFICATION = 31,

  PAYMENT_FAILED = 32,

  NEW_BOOKING_NOTIFICATION = 33,
  BOOKING_MODIFIED_NOTIFICATION = 34,
  BOOKING_CANCELLED_NOTIFICATION = 35,

  CLUB_MEMBERSHIP_REQUEST_APPROVED = 36,
  CLUB_MEMBERSHIP_REQUEST_REJECTED = 37,

  CLUB_REGISTRATION_APPROVED = 38,
  CLUB_REGISTRATION_REJECTED = 39,

  HARBOR_APPROVED = 40,
  HARBOR_REJECTED = 41,

  HARBOR_REGISTRATION_REQUEST = 42,
  NEW_SERVICE_PROVIDER_REGISTRATION = 43,

  SUBSCRIPTION_UPDATED = 44,
  SUBSCRIPTION_CANCELLED = 45,
  SUBSCRIPTION_OVERRIDDEN_ADMIN = 46,

  USER_ACCOUNT_CREATED = 47,
  USER_ACCOUNT_UPDATED = 48,
  USER_ACCOUNT_STATUS_CHANGED = 49,
  USER_ACCOUNT_DELETED = 50,

  POST_CREATED = 51,
  POST_UPDATED = 52,
  POST_LIKED = 53,
  POST_UNLIKED = 54,

  // Post Notifications
  POST_DELETED = 55,
  POST_REPORTED = 56,
  POST_REPORT_RESOLVED = 57,
  POST_COMMENTED = 58,
  POST_COMMENT_LIKED = 59,
  POST_COMMENT_UNLIKED = 60,

  // Club Shift Notifications
  CLUB_SHIFT_CREATED = 61,
  CLUB_SHIFT_ASSIGNED = 62,
  CLUB_SHIFT_UNASSIGNED = 63,
  CLUB_SHIFT_COMPLETED = 64,
  CLUB_INSPECTION_COMPLETED = 65,

  // Service Booking Notifications
  SERVICE_BOOKING_CREATED = 66,
  SERVICE_BOOKING_UPDATED = 67,
  SERVICE_BOOKING_CANCELLED = 68,
  SERVICE_BOOKING_CONFIRMED = 69,
  SERVICE_BOOKING_COMPLETED = 70,
  SERVICE_BOOKING_STATUS_UPDATED = 71,
  NEW_SERVICE_BOOKING = 72,
  CUSTOMER_UPDATED_BOOKING = 73,
  SERVICE_BOOKING_REJECTED = 74,
  SERVICE_BOOKING_APPROVED = 75,

  SUBSCRIPTION_CREATED = 76,
  SUBSCRIPTION_RENEWAL_SUCCESS = 77,
  SUBSCRIPTION_EXPIRY_REMINDER = 78,
  SUBSCRIPTION_EXPIRED = 79,
  SUBSCRIPTION_PAYMENT_FAILED = 80,
  SUBSCRIPTION_PLAN_CHANGED = 81,

  // Mentions in post comments
  POST_COMMENT_MENTIONED = 82,

  SERVICE_BOOKING_PENDING_CONFIRMATION = 83,

  // Community event comments
  EVENT_COMMENTED = 84,
  EVENT_COMMENT_LIKED = 85,
  EVENT_COMMENT_UNLIKED = 86,
  EVENT_COMMENT_MENTIONED = 87,

  // System Announcements
  SYSTEM_ANNOUNCEMENT = 88,
  SERVICE_BOOKING_REMINDER = 89,
  CLUB_RESOURCE_BOOKING_REMINDER = 90,
  CLUB_RESOURCE_BOOKING_UPDATED = 91,
  BOOKING_CONFLICT_ALERT = 92,
  BERTH_REALLOCATION_REQUEST = 113,
  BERTH_REALLOCATION_SUCCESS = 114,
  BERTH_REALLOCATION_DECLINED = 115,
  BERTH_EXTENSION_DECLINED = 116,
  BOOKING_NO_SHOW = 93,
  SERVICE_BOOKING_NO_SHOW = 94,

  // Theme Route Workflow
  THEME_ROUTE_APPROVAL_REQUESTED = 95,
  THEME_ROUTE_APPROVED = 96,
  THEME_ROUTE_REJECTED = 97,
  THEME_ROUTE_PUBLISHED_NOTIFICATION = 98,
  THEME_ROUTE_COMMENT_ADDED = 99,
}

export interface INotificationPreference {
  module_type: NotificationModuleType;
  notification_type: NotificationType;
  is_enabled: boolean;
}

export interface INotificationPreferencesData {
  preferences: INotificationPreference[];
}

export interface IUpdateNotificationPreferencesRequest {
  preferences: {
    notification_type: NotificationType;
    is_enabled: boolean;
  }[];
}
